import {FormArray, FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';

const createFormControlForValue = (
  value: any,
  formBuilder: FormBuilder,
): FormControl | FormGroup => {
  // If it's a complex object with multiple properties, create a FormGroup
  if (value && typeof value === 'object' && !Array.isArray(value) && value !== null) {
    const keys = Object.keys(value);

    // Only create FormGroup if object has multiple meaningful properties
    if (
      keys.length > 1 &&
      !keys.every(
        key => value[key] === null || value[key] === undefined || value[key] === '',
      )
    ) {
      const groupControls: {[key: string]: FormControl} = {};

      keys.forEach(key => {
        const fieldValue = value[key];
        // Add validators for common field patterns
        const validators = [];
        if (
          key === 'question' ||
          key === 'answer' ||
          key === 'title' ||
          key === 'content'
        ) {
          validators.push(Validators.required);
        }

        const controlValue =
          fieldValue !== null && fieldValue !== undefined ? fieldValue : null;

        groupControls[key] = new FormControl(controlValue, validators);
      });

      return formBuilder.group(groupControls);
    }
  }

  // Default: create simple FormControl
  return formBuilder.control(value);
};

export const patchFormGroupAndIncludedFormArrays = (
  formGroup: FormGroup,
  newData: any,
  formBuilder: FormBuilder,
) => {
  formGroup.patchValue(newData);

  for (const [key, value] of Object.entries(newData)) {
    const formElem = formGroup.get(key);

    if (formElem instanceof FormArray && Array.isArray(value)) {
      formElem.clear();
      value.forEach((val: any) => {
        const control = createFormControlForValue(val, formBuilder);
        formElem.push(control);
      });
    }
  }
};
